import initialState from './initialState';
import { reducer as loadLoginPluginConfigurationReducer } from './loadLoginPluginConfiguration';
import { reducer as installLoginPluginReducer } from './installLoginPlugin';
import { reducer as loadCollectionForProjectOnBoardReducer } from './loadCollectionForProjectOnBoard';
import { reducer as loadPopularExtensionReducer } from './loadPopularExtension';
import { reducer as fetchPluginFormReducer } from './fetchPluginForm';
import { reducer as changeProjectStatusReducer } from './changeProjectStatus';
import { reducer as createCollectionReducer } from './createCollection';
import { reducer as createFieldReducer } from './createField';
import { reducer as installAdditionalPluginReducer } from './installAdditionalPlugin';
import { reducer as getXanoSchemaReducer } from './getXanoSchema';
import { reducer as xanoProjectslistReducer } from './xanoProjectslist';
import { reducer as xanocollectionNamesReducer } from './xanocollectionNames';
import { reducer as apisaveDataCallReducer } from './apisaveDataCall';
import { reducer as apicallGetTbalesDataReducer } from './apicallGetTbalesData';
import { reducer as apicallToAddFieldsReducer } from './apicallToAddFields';
import { reducer as createCollectionWithXanoReducer } from './createCollectionWithXano';

const reducers = [
  loadLoginPluginConfigurationReducer,
  installLoginPluginReducer,
  loadCollectionForProjectOnBoardReducer,
  loadPopularExtensionReducer,
  fetchPluginFormReducer,
  changeProjectStatusReducer,
  createCollectionReducer,
  createFieldReducer,
  installAdditionalPluginReducer,
  getXanoSchemaReducer,
  xanoProjectslistReducer,
  xanocollectionNamesReducer,
  apisaveDataCallReducer,
  apicallGetTbalesDataReducer,
  apicallToAddFieldsReducer,
  createCollectionWithXanoReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
